import { api } from "../../../../../Api/Api";

export const getHistory = async () => {
    const [, data] = await api.get(`/open/history`, false)
    return data
}

